module.exports = __webpack_public_path__ + "img/settings_input_component.c2db64a4.svg";